export { InteractiveImage } from "./InteractiveImage";
export type { InteractiveImageProps } from "./InteractiveImage";
export type {
  InteractiveImageExample,
  InteractiveImageCreationResult,
  InteractiveImageGenerate,
  InteractiveImageGenerationInput,
  InteractiveImageGenerationError,
} from "./types";
// CMS-readiness: a future `interactive-image` block renderer maps Payload rows through this
// adapter. creationResults need no adapter — the renderer builds them directly via getImageProps.
export { toInteractiveImageExamples, type InteractiveImageCmsRow } from "./cmsAdapter";
